import { createAction } from 'redux-act';

export const getDecisions = createAction('Get Decisions');
export const decisionsReceived = createAction('Decisions received');

export const decisionsReset = createAction('Reset decisions');
